import { Instagram, MessageCircle, Linkedin } from "lucide-react";
import { SITE, waLink } from "@/config";
import BrandMark from "@/components/BrandMark";

const Footer = () => (
  <footer data-testid="footer" className="bg-navy-deep pb-28 pt-14 md:pb-14">
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col items-start justify-between gap-8 sm:flex-row sm:items-center">
        <BrandMark dark />
        <div className="flex items-center gap-3">
          <a
            data-testid="footer-instagram-link"
            href={SITE.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Medlinkx on Instagram"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-ivory/20 text-ivory/70 transition-colors hover:border-gold hover:text-gold"
          >
            <Instagram className="h-4 w-4" />
          </a>
          <a
            data-testid="footer-linkedin-link"
            href={SITE.linkedinUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Dr. Burhan Shaikh on LinkedIn"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-ivory/20 text-ivory/70 transition-colors hover:border-gold hover:text-gold"
          >
            <Linkedin className="h-4 w-4" />
          </a>
          <a
            data-testid="footer-whatsapp-link"
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Medlinkx on WhatsApp"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-ivory/20 text-ivory/70 transition-colors hover:border-wa hover:text-wa"
          >
            <MessageCircle className="h-4 w-4" />
          </a>
        </div>
      </div>

      <div className="hairline mt-10" />

      <p className="mt-8 text-sm font-semibold text-ivory/70" data-testid="footer-address">
        {SITE.address}
      </p>

      <p className="mt-4 max-w-3xl text-xs leading-relaxed text-ivory/45" data-testid="discreet-disclaimer">
        This product is intended for general wellness and posture support. Counselling is
        educational/professional guidance and does not replace an in-person medical evaluation when
        required. If you notice blood in your stool, severe abdominal pain, vomiting, unexplained
        weight loss, or persistent symptoms, please consult a doctor promptly.
      </p>
      <p className="mt-6 text-xs text-ivory/35">
        © {new Date().getFullYear()} Medlinkx. All rights reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
